import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { OidcAuth } from "@csa/web-foundation";
import { App } from "./App";
import "./styles.css";

const auth = new OidcAuth();
const root = document.getElementById("root");
if (!root) throw new Error("root element missing");
createRoot(root).render(
  <StrictMode>
    <App auth={auth} />
  </StrictMode>,
);
